import {formatIndividualIdentity} from '@sollapay/domain';
import {PartyType} from '@sollapay/enums';

import {getPartyAvatarShape} from '@/utils';

import type {BuyerDTO} from '@sollapay/types';

export function isOrganizationBuyer(partyType: PartyType): boolean {
  return partyType === PartyType.ORGANIZATION;
}

export function getBuyerAvatarShape(partyType: PartyType): 'circle' | 'square' {
  return getPartyAvatarShape(partyType);
}

/** Individuals identify by national ID or passport (with its country); organizations by incorporation number. */
export function getBuyerIdNumber(
  buyer: Pick<BuyerDTO, 'partyType' | 'nationalId' | 'idType' | 'idCountry' | 'organization'>,
  locale: string
): string | null {
  return isOrganizationBuyer(buyer.partyType)
    ? (buyer.organization?.incorporationNumber ?? null)
    : formatIndividualIdentity(
        {idNumber: buyer.nationalId, idType: buyer.idType, idCountry: buyer.idCountry},
        locale
      );
}
